import { render, staticRenderFns } from "./DistributionApply.vue?vue&type=template&id=8780df5e&scoped=true"
import script from "./DistributionApply.vue?vue&type=script&lang=js"
export * from "./DistributionApply.vue?vue&type=script&lang=js"
import style0 from "./DistributionApply.vue?vue&type=style&index=0&id=8780df5e&prod&scoped=true&lang=css"
import style1 from "./DistributionApply.vue?vue&type=style&index=1&id=8780df5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8780df5e",
  null
  
)

export default component.exports